import { Autocomplete, Grid, TextField } from '@mui/material'
import Dropzone, { ILayoutProps } from 'react-dropzone-uploader'
import { useTranslation } from 'react-i18next'
import 'react-dropzone-uploader/dist/styles.css'

interface SupportMaterialTabProps {
  seminarLessonState: any
  novelties: any[]
  handleMultiAutoCompleteChange: (inputName: string, value: any) => void
  getUploadParams: ({ meta }: any) => any
}

const Layout = ({ input, previews, submitButton, dropzoneProps, files, extra: { maxFiles } }: ILayoutProps) => {
  return (
    <div>
      {previews}
      <div {...dropzoneProps}>{files.length < maxFiles && input}</div>
      {files.length > 0 && submitButton}
    </div>
  )
}

export const SupportMaterialTab = ({
  seminarLessonState,
  novelties,
  handleMultiAutoCompleteChange,
  getUploadParams
}: SupportMaterialTabProps) => {
  const { t } = useTranslation(['global'])

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Autocomplete
          id="combo-box-novelties"
          value={novelties.filter((novelty: any) => seminarLessonState.novelties.includes(novelty.id))}
          onChange={(_event, value) => handleMultiAutoCompleteChange('novelties', value)}
          options={novelties}
          multiple
          getOptionLabel={(option: any) => (option.id !== undefined ? option.title : '')}
          renderInput={params => <TextField {...params} label={t('novelties')} variant="filled" InputLabelProps={{ shrink: true }} />}
        />
      </Grid>

      <Grid item xs={12}>
        <Dropzone
          getUploadParams={getUploadParams}
          LayoutComponent={Layout}
          classNames={{
            dropzone: 'dzu-dropzone-custom',
            inputLabel: 'dzu-inputlabel-custom'
          }}
          inputContent={t('dropzone-drop-text')}
        />
      </Grid>
    </Grid>
  )
}
